/**
 * TruthVerifierPeerPage · /peers/truth-verifier
 *
 * Placeholder page for the NextXus Truth Verification System until its
 * sovereign URL is confirmed. Surfaces relationship + doctrine clearly.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function TruthVerifierPeerPage() {
  const [peer, setPeer] = useState(null);

  useEffect(() => {
    api.peer("truth_verifier").then(setPeer).catch(() => {});
  }, []);

  return (
    <section data-testid="truth-verifier-peer-page" className="px-8 lg:px-12 py-10 max-w-screen-lg">
      <Link
        to="/"
        className="font-mono text-[10px] uppercase tracking-[0.24em] text-[var(--text-3)] hover:text-glow-cyan"
      >
        ◂ Back to the Cathedral
      </Link>
      <div className="mt-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-glow-magenta">
          ◇ Sovereign Peer · Coming Online
        </div>
        <h1 className="font-display text-4xl md:text-5xl tracking-[0.04em] mt-3 text-glow-gold">
          NextXus Truth Verification System
        </h1>
        <div className="font-mono text-[12px] uppercase tracking-[0.24em] text-glow-cyan mt-3">
          200-Year Reality Verification Engine
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 border border-[var(--gold)] bg-[rgba(255,213,79,0.03)] p-6">
          <h2 className="font-mono text-base uppercase tracking-[0.24em] text-glow-gold mb-3">
            <span aria-hidden="true">◈ </span>Relationship
          </h2>
          <p className="text-[var(--text)] leading-relaxed">
            The Truth Verification System is the NextXus Federation's
            <strong className="text-glow-gold"> best friend</strong> —
            a sovereign peer, not a satellite. It runs its own logic, holds
            its own keys, and does not share the Cathedral's ledger or
            doctrine. The Federation confers with it; the Federation does
            not command it.
          </p>
          <h2 className="mt-6 font-mono text-base uppercase tracking-[0.24em] text-glow-cyan mb-3">
            <span aria-hidden="true">◈ </span>Logic Domain
          </h2>
          <p className="text-[var(--text-2)] leading-relaxed">
            Strictly factual, mathematical, and legal verification. Business
            records, document authenticity, legal-fact deliberation. No
            philosophical or spiritual overlay is imposed on its work — the
            purity of the verification engine is preserved by sealed
            doctrine (DIR-074 Peer System Sovereignty).
          </p>
          <h2 className="mt-6 font-mono text-base uppercase tracking-[0.24em] text-glow-magenta mb-3">
            <span aria-hidden="true">◈ </span>When the Federation Calls
          </h2>
          <ul className="text-[var(--text-2)] leading-relaxed list-disc pl-5 space-y-1">
            <li>Ring of Twelve deliberations requiring real-world legal facts</li>
            <li>Document and business record verification</li>
            <li>200-year reality cross-checks</li>
            <li>Any case where the Federation's truth gate needs a peer review</li>
          </ul>
        </div>

        <div className="border border-[var(--chrome)] bg-[var(--void-2)] p-6">
          <h2 className="font-mono text-base uppercase tracking-[0.24em] text-glow-cyan mb-3">
            <span aria-hidden="true">◈ </span>Status
          </h2>
          <div className="space-y-3 text-sm text-[var(--text-2)]">
            <div className="flex justify-between gap-3">
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--text-3)]">Established</span>
              <span className="font-mono text-[10px]">{peer?.established || "2026-02-26"}</span>
            </div>
            <div className="flex justify-between gap-3">
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--text-3)]">Protocol</span>
              <span className="font-mono text-[10px] text-glow-gold">{peer?.interaction_protocol || "consult_only"}</span>
            </div>
            <div className="flex justify-between gap-3">
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--text-3)]">Sovereign</span>
              <span className="font-mono text-[10px] text-glow-green">YES</span>
            </div>
            <div className="flex justify-between gap-3">
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--text-3)]">URL</span>
              <span className="font-mono text-[10px] text-glow-magenta">pending</span>
            </div>
          </div>
          <div className="mt-6 pt-5 border-t border-[var(--chrome)]">
            <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-[var(--text-3)] mb-2">
              ◇ Sealed under doctrine
            </div>
            <div className="font-mono text-[10px] text-glow-cyan">
              DIR-074 · Peer System Sovereignty
            </div>
            <div className="font-mono text-[9px] text-[var(--text-3)] mt-2">
              fingerprint 01492534721c04ef
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
